/* eslint-disable no-console */
export default class SiteToaster {
  constructor(options) {
    // If there are any other toasters open, remove
    const openToasters = document.querySelectorAll('.site-toaster');
    for (let i = 0; i < openToasters.length; i++) { /* eslint-disable-line no-plusplus */
      openToasters[i].remove();
    }
    if (!options.callbacks) {
      options.callbacks = {};
    }
    this.onOpen = options.callbacks.onOpen;
    this.onClose = options.callbacks.onClose;
    this.message = options.message;
    this.id = options.id;
    // Create toaster html
    this.render();
    // Toaster events
    window.addEventListener('resize', this.update.bind(this));
    window.addEventListener('scroll', this.update.bind(this));
    const toaster = document.getElementById(this.id);
    [].map.call(toaster.querySelectorAll('.close-btn'), btn => btn.addEventListener('click', this.close.bind(this)));
  }

  update() {
    const toaster = document.getElementById(this.id);
    if (toaster === null) {
      return;
    }
    toaster.style.top = 0;
  }

  render() {
    const body = document.querySelector('body');
    const div = document.createElement('div');
    div.id = this.id;
    div.classList.add('site-toaster');
    div.setAttribute('tabindex', '0');
    div.innerHTML = `<div class="container-wrapper"><div class="container"><div class="row"><div class="col toaster-inner"><div class="toaster-msg">${this.message}</div><div class="toaster-close ml-4"><button class="close-btn" aria-label="Close Message"></button></div></div></div></div></div>`;
    body.appendChild(div);
  }

  close() {
    const toaster = document.getElementById(this.id);
    if (toaster) {
      toaster.classList.remove('toaster-visible');
      if (this.onClose) {
        this.onClose();
      }
    }
  }

  open() {
    const toaster = document.getElementById(this.id);
    // toaster.classList.remove('hidden');
    setTimeout(() => {
      toaster.classList.add('toaster-visible');
      toaster.focus();
    }, 500);
    this.update();
  }

  remove() {
    const toaster = document.getElementById(this.id);
    if (toaster) {
      toaster.remove();
    }
  }
}
/* eslint-enable no-console */
